import angularModule from 'Cohorts/angularModule/scripts/cohorts_module';

angularModule.factory('CurriculumTemplate', [
    '$injector',
    $injector => {
        const Iguana = $injector.get('Iguana');
        const Schedulable = $injector.get('Schedulable');

        // oxlint-disable-next-line func-names
        return Iguana.subclass(function () {
            this.setCollection('curriculum_templates');
            this.alias('CurriculumTemplate');
            this.setIdProperty('id');
            this.include(Schedulable);

            // oxlint-disable-next-line func-names
            this.setCallback('after', 'copyAttrsOnInitialize', function () {
                this.specialization_playlist_pack_ids = this.specialization_playlist_pack_ids || [];
                this.periods = this.periods || [];
                this.computePeriodDates();
            });

            // This is not actually saved to the db, but it is used in the admin.
            // It follows the structure of cohort
            Object.defineProperty(this.prototype, 'startDate', {
                get() {
                    if (!this.$$startDate) {
                        this.$$startDate = this.computeDefaultStartDate();
                    }
                    return this.$$startDate;
                },
                set(val) {
                    this.$$startDate = val;
                },
            });
        });
    },
]);
